import request from '@/utils/request'

// 分页查询教育课程订单
export function pageEduCourseOrder(data) {
  return request({
    url: '/biz/admin/edu/course/order/page',
    method: 'post',
    data: data
  })
}

// 教育课程订单详情
export function getEduCourseOrder(data) {
  return request({
    url: '/biz/admin/edu/course/order/detail',
    method: 'post',
    data: data
  })
}
